<template>
  <v-data-table
    :footer-props="{
      'items-per-page-text': 'Số dữ liệu mỗi trang',
      'items-per-page-options': [10, 20, 50]
    }"
    disable-sort
    :headers="headers"
    :items="invoices"
    :loading="loading"
    :items-per-page="itemsPerPage"
    :server-items-length="count"
    @update:page="val => updatePagination('page', val)"
    @update:items-per-page="val => updatePagination('itemsPerPage', val)"
    hide-default-header
  >
    <template v-slot:header>
      <thead>
        <tr>
          <th
            v-for="header in headers"
            :key="header.value"
            :style="{ width: header.width, 'text-align': header.align ? header.align : 'left' }"
          >
            <span v-html="headerTextWithBreaks(header.text)"></span>
          </th>
        </tr>
      </thead>
    </template>
    <template v-slot:no-data>
      <div class="my-12 font-weight-bold">
        <p>Không có dữ liệu</p>
      </div>
    </template>
    <template v-slot:[`body.prepend`]>
      <tr>
        <td colspan="1">
          <BaseSmallInput placeholder="Nhập mã HĐ" @change="searchWithOption" v-model="filter.code_contains" />
        </td>
        <td colspan="1">
          <SmallSelect
            style="width: 90px"
            placeholder="Chọn NH"
            entity="industries"
            @changeSelect="
              val => {
                selectChange('productIndustry', val)
                searchWithOption({ productIndustry: val })
              }
            "
          />
        </td>
        <td colspan="1">
          <SmallSelect
            style="width: 100px"
            ref="producerSelect"
            placeholder="Chọn NSX"
            entity="producers"
            :params="{ productIndustry: filter.productIndustry }"
            @changeSelect="
              val => {
                selectChange('producer', val)
                searchWithOption({ producer: val })
              }
            "
          />
        </td>
        <td colspan="1">
          <SmallSelect
            style="width: 115px"
            ref="productTypeSelect"
            placeholder="Chọn CH"
            entity="productTypes"
            :params="{ producer: filter.producer, productIndustry: filter.productIndustry }"
            @changeSelect="
              val => {
                selectChange('productType', val)
                searchWithOption({ productType: val })
              }
            "
          />
        </td>
        <td></td>
        <td>
          <BaseSmallInput
            placeholder="Nhập mã đơn"
            @change="searchWithOption"
            v-model="filter.importOrderCode_contains"
          />
        </td>
        <td>
          <SmallSelect
            style="width: 110px"
            placeholder="Chọn kho"
            entity="inventories"
            @changeSelect="
              data => {
                filter.inventory = data
                searchWithOption(data)
              }
            "
          />
        </td>
        <td>
          <StatusSelect
            :items="auditProductSelect"
            @onChangeStatus="
              data => {
                filter.deliveryStatus = data
                searchWithOption(data)
              }
            "
          ></StatusSelect>
        </td>
        <td></td>
        <td class="text-red text-right">{{ beautifulMoney(totalPrice) }}</td>
        <td></td>
      </tr>
    </template>
    <template v-slot:[`item.code`]="{ item }">
      <router-link
        style="text-decoration: none"
        :to="$auth.policies['import-invoices:detail'] ? `/import-bill/${item.id}` : ''"
      >
        <div style="white-space: nowrap">
          <div :class="item.idIpmportBill ? 'text-blue' : 'text-red'">
            {{ get(item, 'code', '[Chưa có mã]') }}
          </div>
        </div>
      </router-link>
    </template>
    <template v-slot:[`item.productIndustry`]="{ item }">
      {{ get(item, 'productIndustry.name', '') }}
    </template>
    <template v-slot:[`item.producer`]="{ item }">
      {{ get(item, 'producer.name', '') }}
    </template>
    <template v-slot:[`item.productType`]="{ item }">
      {{ get(item, 'productType.name', '') }}
    </template>
    <template v-slot:[`item.createdAt`]="{ item }">
      {{ formatDateDDMMYYYY(item.createdAt) }}
    </template>
    <template v-slot:[`item.inventory`]="{ item }">
      {{ get(item, 'inventory.name', '') }}
    </template>
    <template v-slot:[`item.deliveryStatus`]="{ item }">
      <TextStatus :status="get(item, 'deliveryStatus', '')" type="audit"></TextStatus>
    </template>
    <template v-slot:[`item.releaseDate`]="{ item }">
      {{ get(item, 'releaseDate') ? formatDateDDMMYYYY(get(item, 'releaseDate')) : '--' }}
    </template>
    <template v-slot:[`item.priceAfterTax`]="{ item }">
      {{ beautifulMoney(get(item, 'priceAfterTax', '--')) }}
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon @click="$router.push(`/import-bill/${item.id}`)" size="20" color="primary">mdi-eye</v-icon>
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import SmallSelect from '../../components/samnec/SmallSelect.vue'
import TextStatus from '@/components/samnec/TextStatus.vue'
import StatusSelect from '@/components/basic/StatusSelect.vue'
import { formatDateDDMMYYYY } from '@/helpers/date.js'
import { get } from 'lodash'
import BaseSmallInput from '../../components/basic/BaseSmallInput.vue'
import { auditProductSelect } from '../../helpers/data'
export default {
  components: { SmallSelect, TextStatus, StatusSelect, BaseSmallInput },
  data() {
    return {
      headers: [
        { text: '<div style="width: 120px">Hoá đơn nhập</div>', value: 'code' },
        { text: '<div style="width: 90px">Ngành hàng</div>', value: 'productIndustry' },
        { text: '<div style="width: 100px">NSX</div>', value: 'producer' },
        { text: '<div style="width: 115px">Chủng hàng</div>', value: 'productType' },
        { text: '<div style="width: 60px">Ngày xuất hóa đơn</div>', value: 'createdAt', align: 'left' },
        { text: ' <div style="width: 90px">Đơn hàng nhập tương ứng</div>', value: 'importOrderCode' },
        { text: '<div style="width: 110px">Kho</div>', value: 'inventory' },
        { text: '<div style="width: 100px">Trạng thái giao</div>', value: 'deliveryStatus' },
        { text: '<div style="width: 60px">Công nợ <br> tính từ</div>', value: 'releaseDate', align: 'end' },
        { text: '<div style="width: 110px">Tổng tiền</div>', value: 'priceAfterTax', align: 'right' },
        { text: '<div style="width: 50px">Thao tác</div>', value: 'actions', align: 'center' }
      ],
      filter: {
        status: 'open',
        code_contains: '',
        productIndustry: '',
        producer: '',
        productType: '',
        importOrderCode_contains: '',
        inventory: '',
        deliveryStatus: '',
        createdAt_lte: null,
        createdAt_gte: null
      },
      totalPrice: 0,
      get
    }
  },
  computed: mapState({
    auditProductSelect: auditProductSelect,
    invoices(state) {
      return state['importInvoices'].items
    },
    count(state) {
      return state['importInvoices'].count
    },
    itemsPerPage(state) {
      return state['importInvoices'].itemsPerPage
    },
    searchQuery(state) {
      return state['importInvoices'].searchQuery
    },
    loading(state) {
      return state['importInvoices'].loading
    }
  }),
  methods: {
    ...mapActions({
      fetchImportInvoices: 'importInvoices/fetchItems',
      countInvoices: 'importInvoices/countItems',
      setItemsPerPage: 'importInvoices/setItemsPerPage',
      getStats: 'importInvoices/getStatsIndependence'
    }),
    formatDateDDMMYYYY: formatDateDDMMYYYY,
    formatAdress(address) {
      const splitAddress = address.split('-')
      return splitAddress[splitAddress.length - 1]
    },
    beautifulMoney(m) {
      return m !== null && m !== undefined ? Number(m).toLocaleString('en-US') : '--'
    },
    async updatePagination(type, val) {
      const page = type === 'page' ? val : 1
      const itemsPerPage = type === 'itemsPerPage' ? val : this.itemsPerPage
      await this.fetchImportInvoices({
        _start: type === 'itemsPerPage' ? 0 : (page - 1) * itemsPerPage,
        _limit: itemsPerPage,
        ...this.filter
      })
      this.setItemsPerPage(itemsPerPage)
    },
    async searchWithOption(val = null) {
      const gte = get(val, 'createdAt_gte')
      const lte = get(val, 'createdAt_lte')
      if (gte && lte) {
        this.filter.createdAt_lte = lte
        this.filter.createdAt_gte = gte
      }
      await this.fetchImportInvoices({ _start: 0, _limit: this.itemsPerPage, ...this.filter })
      await this.countInvoices({ ...this.filter })
      this.totalPrice = await this.getStats({
        id: 'list',
        params: { ...this.filter }
      })
    },
    selectChange(type, val) {
      if (type === 'productIndustry') {
        this.filter.productIndustry = val
        setTimeout(() => {
          this.$refs.producerSelect.changeItems()
          this.$refs.productTypeSelect.changeItems()
        }, 100)
      }
      if (type === 'producer') {
        this.filter.producer = val
        setTimeout(() => {
          this.$refs.productTypeSelect.changeItems()
        }, 100)
      }
      if (type === 'productType') this.filter.productType = val
    },
    formatPrice(val) {
      return val.toLocaleString('vi-VN', { currency: 'VND' })
    },
    formatNumberWithDot(number) {
      return new Intl.NumberFormat('en-US').format(number)
    },
    headerTextWithBreaks(text) {
      return text.replace('<br/>', '<br>')
    }
  },
  async created() {
    const params = { status: 'open' }
    await this.fetchImportInvoices({ ...params, _start: 0, _limit: 10 })
    await this.countInvoices(params)
    this.totalPrice = await this.getStats({
      id: 'list',
      ...params
    })
  },
  watch: {
    searchQuery: {
      handler(val) {
        if (val) this.filter = { ...this.filter, ...val }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>
<style lang="scss">
td,
th {
  padding: 0 8px !important;
}
</style>
<style lang="scss" scoped>
@import 'src/assets/importOrder/table-list-product.scss';
.text-red {
  color: red;
}

.text-blue {
  color: #0d47a1;
}
</style>
